<template>
  <section :data-domain="props.data.domain?.color?.name" class="person-card">
    <NuxtLink
        class="person-card__link"
        :href="`/person/${joinSlugId(props.data)}/`"
    >
      <AppPersonMask :image="props.data.image" :renditions="renditions" class="person-card__person-mask" aria-hidden="true"/>
      <component :is="computedValue" class="person-card__person-mask-shape"/>
      <h3 class="person-card__title" v-html="props.data.title"></h3>
      <p class="person-card__text" v-if="props.data.subtitle">{{ props.data.subtitle }}</p>
    </NuxtLink>
  </section>
</template>

<script setup lang="ts">
import {TImageRendition} from '~/types/other-types'
import {TPersonPage} from '~/types/page-types'
import {TPersonItem} from '~/types/block-types'
import {joinSlugId} from "~/utils/slug-id";
import * as oOutline from 'assets/svg/o-outline.svg'
import {computed} from "vue";

const renditions: TImageRendition[] = [
  {width: 286, height: 286, breakpoint: 'xs'},
  {width: 320, height: 320, breakpoint: 'md'},
]

const props = defineProps<{
  data: TPersonPage | TPersonItem,
}>()

const computedValue = computed(() => {
  return oOutline
})
</script>

<style scoped lang="postcss">
.person-card {
  width: 320px;

  &__link {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  &__person-mask {
    margin-bottom: 1.25rem;
    margin-top: 5px;
  }

  &__person-mask-shape {
    position: absolute;
    top: 0px;
    height: auto;
    width: calc(100% + 10px);
  }

  &__title {
    margin-bottom: 0.5rem;
    hyphens: auto;
    font-family: Midnight, sans-serif;
    font-size: 28px;
    text-transform: uppercase;
    line-height: 0.9;
    color: var(--color-blue-aqua);
  }

  &__text {
    line-height: 1.1;
    color: var(--color-blue-aqua);
  }

  &[data-domain="red"] {
    color: var(--color-red);
  }

  &[data-domain="violet"] {
    color: var(--color-violet);
  }

  &[data-domain="yellow"] {
    color: var(--color-yellow);
  }
}
</style>
